import { createEntityAdapter, createSlice, EntityState, PayloadAction } from '@reduxjs/toolkit';

import { ChatMessage } from '../chatTypes';
import { ascDateComparer } from '../chatServices';

interface SupportChatState {
  isFetching: boolean;
  isImageUploading: boolean;
  messages: EntityState<ChatMessage>;
  hasMore: boolean;
}

export const messageAdaptor = createEntityAdapter<ChatMessage>({
  selectId: (message) => message.id,
  sortComparer: (a, b) => ascDateComparer(a.createdAt, b.createdAt),
});

const initialState: SupportChatState = {
  isFetching: true,
  isImageUploading: false,
  messages: messageAdaptor.getInitialState(),
  hasMore: false,
};

const supportChatSlice = createSlice({
  name: 'supportChat',
  initialState,
  reducers: {
    fetchMessages: (state, action: PayloadAction<{ offset: number }>): void => {},
    sendMessage: (state, action: PayloadAction<{ text: string; image?: object }>): void => {},
    uploadImage: (state, action: PayloadAction<{ formData: object }>): void => {},
    setIsFetching: (state, action: PayloadAction<boolean>): SupportChatState => ({
      ...state,
      isFetching: action.payload,
    }),
    setIsImageUploading: (state, action: PayloadAction<boolean>): SupportChatState => ({
      ...state,
      isImageUploading: action.payload,
    }),
    setHasMore: (state, action: PayloadAction<boolean>): SupportChatState => ({
      ...state,
      hasMore: action.payload,
    }),
    messagesReceived: (state, action: PayloadAction<ChatMessage[]>): void => {
      messageAdaptor.upsertMany(state.messages, action);
    },
    messageReceived: (state, action: PayloadAction<ChatMessage>): void => {
      messageAdaptor.upsertOne(state.messages, action);
    },
    reset: (): SupportChatState => ({
      ...initialState,
    }),
  },
});

export const supportChatActions = supportChatSlice.actions;
export const supportChatReducer = supportChatSlice.reducer;
